var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.674 21.909c0 0 3.33-2.278 3.33-6.771 0-6.688-7.088-9.161-10.899-9.095-3.812 0.067-4.948 1.070-4.948 1.070s-1.297-0.943-2.672-1.733c-1.052-0.41-1.296-0.469-2.027-0.234-0.585 0-0.217 0.974 0.018 1.325 0.233 0.351 1.366 2.29 1.366 2.29s-2.378 2.449-2.554 4.059c0-0.029-1.12-0.009-1.734-0.009s-0.556 0.669-0.556 0.669l0.017 4.714c0 0-0.038 0.669 0.519 0.669 0.556 0 1.738 0.013 1.738 0.013s1.663 2.415 2.717 2.854c0 0.029-0.911 2.503-0.911 2.503s-0.439 0.761 0.351 1.054c0.79 0.292 2.851 1.157 3.729 1.421s1.003-0.334 1.003-0.334l0.869-1.877 5.685 0.009 0.869 1.935c0 0 0.167 0.898 1.337 0.401 1.171-0.497 2.449-1.087 3.415-1.584 0.965-0.497 0.33-1.426 0.33-1.426l-0.992-1.923zM9.322 13.764c-0.533 0-0.965-0.433-0.965-0.966s0.432-0.965 0.965-0.965 0.966 0.432 0.966 0.965-0.433 0.966-0.966 0.966zM22.925 10.756c-0.308 0.365-0.509 0.096-0.757 0.023 0 0-1.051-0.975-2.595-1.43-1.599-0.47-3.282-0.243-3.282-0.243-0.248-0.073-0.549-0.081-0.551-0.464 0.013-0.473 0.587-0.477 0.58-0.493 0 0 1.894-0.175 3.479 0.291 1.559 0.458 2.75 1.454 2.75 1.454s0.637 0.439 0.376 0.862z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPig);
export default __webpack_public_path__ + "static/media/pig.fc3335c5dda42862d552edc80f00dac7.svg";
export { ForwardRef as ReactComponent };